<template>
    <v-dialog v-model="dialog" scrollable fullscreen>
        <v-card>
            <v-card-title class="text-h5 dialog-title">
                {{ protocolo.id ? "Actualizar" : "Crear" }} Protocolo
            </v-card-title>
            <v-card-text>
                <v-form ref="form" v-model="formValid" class="mt-3">
                    <div class="form-header">
                        <v-row>
                            <v-col cols="12" md="6">
                                <v-text-field
                                    label="Titulo"
                                    v-model="protocolo.titulo"
                                    outlined
                                    dense
                                    :rules="[rules.required]"
                                >
                                </v-text-field>
                            </v-col>
                            <v-col cols="12" md="6">
                                <v-autocomplete
                                    label="Modulo"
                                    v-model="protocolo.id_protocolo_modulo"
                                    :items="modulos"
                                    item-text="nombre"
                                    item-value="id"
                                    outlined
                                    dense
                                    :rules="[rules.required]"
                                >
                                </v-autocomplete>
                            </v-col>
                        </v-row>
                    </div>
                    <v-row>
                        <v-col cols="12">
                            <!-- <v-textarea
                                label="Descripcion"
                                v-model="protocolo.descripcion"
                                outlined
                                dense
                                :rules="[rules.required]"
                            >
                            </v-textarea> -->
                            <h4>Descripción</h4>
                            <RichTextComponent
                                v-model="protocolo.descripcion"
                                uploadUrl="api/protocolo/image"
                                :fixedToolbar="true"
                            ></RichTextComponent>
                        </v-col>
                    </v-row>
                </v-form>
            </v-card-text>
            <v-card-actions class="d-flex justify-center">
                <v-btn @click="dialog = false" color="error" class="white--text"
                    >Cancelar</v-btn
                >
                <v-btn
                    v-if="!protocolo.id"
                    color="success"
                    class="white--text"
                    @click="saveProtocolo"
                    >Guardar</v-btn
                >
                <v-btn
                    @click="saveProtocolo"
                    v-if="protocolo.id"
                    color="success"
                    class="white--text"
                    >Actualizar</v-btn
                >
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { rules } from "../../../utils/rules";
import RichTextComponent from "../../tickets/componentes/RichTextComponent.vue";

export default {
    components: {
        RichTextComponent,
    },
    props: ["value", "item"],
    data() {
        return {
            rules: rules,
            formValid: true,
            dialog: false,
            modulos: [],
            protocolo: {
                id: null,
                titulo: null,
                descripcion: null,
                id_protocolo_modulo: null,
            },
        };
    },
    async created() {
        await this.getModulos();
    },
    methods: {
        async getModulos() {
            const res = await axios.get(`api/get-protocolo-modulos`);
            this.modulos = res.data;
        },
        async saveProtocolo() {
            try {
                this.$refs.form.validate();

                if (!this.formValid) {
                    return;
                }

                let res = null;
                if (this.protocolo.id) {
                    res = await axios.put(
                        `api/update-protocolo/${this.protocolo.id}`,
                        this.protocolo
                    );
                } else {
                    res = await axios.post(
                        "api/create-protocolo",
                        this.protocolo
                    );
                }

                this.$emit("refresh");
                this.$toast.success(res.data.message);
                this.dialog = false;
            } catch (error) {
                this.$toast.error(error?.response?.data?.message);
            }
        },
    },
    watch: {
        value(val) {
            this.dialog = val;
        },
        dialog(val) {
            this.$emit("input", val);
        },
        item: {
            handler(val) {
                if (val) {
                    this.protocolo = { ...val };
                }
            },
            immediate: true,
        },
    },
    computed: {
        //
    },
};
</script>
<style scoped>
.form-header {
    position: sticky;
    top: 0;
    z-index: 200; /* Mayor z-index para estar por encima */
    background: white;
    padding: 16px 0;
    border-bottom: 1px solid #e0e0e0;
    margin-bottom: 16px;
}

.v-card-text {
    height: calc(100vh - 200px);
    overflow-y: auto;
}

.rich-text-container {
    height: calc(100% - 100px);
}
</style>
